import React from 'react'
import {
  number, string,
} from 'prop-types'

import UserCard from '../../UserCard/UserCard'
import ModelActions from './ModelActions'

function ModelInfoSidebarFooter({
  username = null,
  userPicture = null,
  reviewCount = 0,
  userRating = 0,
  ...rest
}) {
  return (
    <div className="gallery-sidebar-footer">
      <UserCard
        username={username}
        userPicture={userPicture}
        reviewCount={reviewCount}
        userRating={userRating}
      />
      <ModelActions {...rest} />
    </div>
  )
}

ModelInfoSidebarFooter.propTypes = {
  username: string,
  userPicture: string,
  reviewCount: number,
  userRating: number,
}

export default ModelInfoSidebarFooter
